import Tag from "components/Tag/Tag";
import React from "react";

interface Props {
  hsCompany: server.dto.HubSpotCompany
}

const HubSpotLifecycleTag = (props: Props) => {

  let color = "purple-basic";

  switch (props.hsCompany.lifecycleStageLabel.toLowerCase()) {
    case "customer": color = "green"; break;
    case "opportunity": color = "orange"; break;
    case "lead": color = "blue"; break;
  }

  return <Tag
    color={color}
    label={props.hsCompany.lifecycleStageLabel}
  />
};

export default HubSpotLifecycleTag;